export default __webpack_public_path__ + "56e79d3d9863ead4e2a2a799bbcfe714.svg";